import ProductDescription from './ProductDescription'

const InfantFruitsAndVegsProduct = {
  ...ProductDescription,
  category: '12',
  subCategory: '001',
  IsBroadband: true,
  ProductType: 'Fruit',
  PackageType: '',
  PacketSize: '4 ounces only',
  MultiPackageType: false,
  MultiPackageCount: '',
  Organic: false,
  NoAdditionalIngredients: false,
}

export default InfantFruitsAndVegsProduct
